// Generated by content:build from libs/content/src. Do not edit.
import type { ContentSet } from '../../../model';

/** Staging, previews and local: drafts included. */
export const CONTENT: ContentSet = {
  locale: 'cs',
  articles: () => import('./articles').then(module => module.default),
  references: () => import('./references').then(module => module.default),
  jobs: () => import('./jobs').then(module => module.default),
  people: () => import('./people').then(module => module.default),
  events: () => import('./events').then(module => module.default),
};
